// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"qxbe9B76"};